export default __webpack_public_path__ + "static/media/anna-logo.99851e32.png";